










































































































import { Vue, Component, Prop, Watch } from "vue-property-decorator";
import { LayerMaterials } from "../../types/TrialPitLayers";
import { StrataBelowRefChoices } from "../../types/TrialPitDetails";

export interface PitDetailModel {
  width: number;
  height: number;
  depth: number;
  groundLevel: number;
  groundLevelLabel: string;
  aboveGroundMaterial: string;
  strataBelowRef: string;
}

@Component({})
export default class PitDetails extends Vue {
  @Prop({
    default: () => ({
      width: 0,
      height: 0,
      depth: 0,
      groundLevel: 0,
      groundLevelLabel: "GROUND LEVEL",
      aboveGroundMaterial: "brick",
      strataBelowRef: "boreHole"
    })
  })
  private value!: PitDetailModel;
  private internalValue: PitDetailModel = {
    width: 0,
    height: 0,
    depth: 0,
    groundLevel: 0,
    groundLevelLabel: "GROUND LEVEL",
    aboveGroundMaterial: "brick",
    strataBelowRef: "Bore Hole"
  };

  private strataBelowRefChoices = StrataBelowRefChoices;

  private allowedAboveGroundMaterials: string[] = [
    "none",
    "brick",
    "bituminous",
    "concrete",
    "102",
    "sand",
    "slab",
    "other"
  ];

  private get aboveGroundMaterialChoices() {
    return LayerMaterials.filter(
      l => this.allowedAboveGroundMaterials.indexOf(l.value) !== -1
    );
  }

  @Watch("value", { deep: true })
  protected updateInternalValue() {
    this.internalValue = this.value;
  }

  protected mounted() {
    this.updateInternalValue();
  }

  protected valueChanged() {
    this.$emit("input", this.internalValue);
  }
}
